<a [href]="content().url" [innerHTML]="content().title|appTranslate|async" target="_blank"></a>
